import { AllClose } from '@vtbhome/juicyfront/indexIcon';
import React from 'react';
import { CloseWrapper, Content, IconWrapper, Wrapper } from './toast.styles';
import { Typography } from '../typography/typography';
import { ToastProps } from './types';
import { ICON_MAP } from './toast.mixins';

export const Toast: React.FC<ToastProps> = ({ type = 'info', title, description, onClose }) => {
    return (
        <Wrapper $type={type}>
            <IconWrapper $type={type}>{ICON_MAP[type]}</IconWrapper>
            <Content>
                {title && <Typography size='subtitle3'>{title}</Typography>}
                {description && <Typography size='subtitle3'>{description}</Typography>}
            </Content>
            {onClose && (
                <CloseWrapper>
                    <AllClose size='xxs' color='#505258' onClick={onClose} />
                </CloseWrapper>
            )}
        </Wrapper>
    );
};
